import { ROUTER_PATHS, gridSize, newTransferenciaSchema, texto, useUploadFile } from "@/shared";
import { SingleTableBoxScene, TabTextLabel } from "@/shared/components/ui";
import { Grid, Paper } from "@mui/material";
import { 
  AlertSeverityEnum, MaterialTransferido, 
  EstadoSolicitudTransferencia, ISolicitudTrasladoForm 
} from "@/shared/interfaces";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useUiStore } from "@/store/ui";
import { yupResolver } from "@hookform/resolvers/yup";
import { useAuthStore } from "@/store/auth";
import DatosTransferenciaComponente from "../componente/datos-transferencia-componente";
import { useFetchCreateSolicitudTransferenciaProducto } from "@/shared/actions/erp";
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import { useNavigate } from "react-router-dom";
import SampleTablePagination from "@/shared/components/ui/SampleTablePagination";
import { useTableColumnsInventarioSerie } from "@/shared/hooks/useTableColumnsInventarioSerie";
import { useCargarSeriesProductos } from "@/store/erp/productos/useCargarSeriesProductos.store";
import { CustomAlertCard } from "@/shared/components/ui/Alerts";
import ModalUbicacionProductoSelectComponente from "../ingreso-producto/shared/componente/ModalUbProductoSelectComponente";

export default function SolicitudTransferenciaInventarioCreatePage() {


  const navigate = useNavigate();

  ///* react query
  const fetchCreateSolicitudTransferenciaProducto
    = useFetchCreateSolicitudTransferenciaProducto({
    });

  ///* form
  const form = useForm<ISolicitudTrasladoForm, any, ISolicitudTrasladoForm>({
    resolver: yupResolver(newTransferenciaSchema),
    defaultValues: {
      solicitado_por: "",
    }
  });

  const {
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = form;

  ///* store
  const setConfirmDialog = useUiStore(s => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiStore(s => s.setConfirmDialogIsOpen);
  const { columnsSolicitudTransferenciaInventario } = useTableColumnsInventarioSerie()
  const handleAgregarUrlSerie = useCargarSeriesProductos(s => s.handleAgregarUrlSerie)
  const { handleUploadFile } = useUploadFile();
  const setAlert = useUiStore(s => s.setAlert);
  const username = useAuthStore(s => s.user?.username);
  const paginatedData = useCargarSeriesProductos(s => s.paginatedData)
  const productos = useCargarSeriesProductos(s => s.productos)
  const setPagination = useCargarSeriesProductos(s => s.setPagination)
  const pagination = useCargarSeriesProductos(s => s.pagination)
  const handleAgregarProducto = useCargarSeriesProductos(s => s.handleAgregarProducto)
  const clearSelectedItems = useCargarSeriesProductos(s => s.clearSelectedItems)

  useEffect(() => {
    return () => {
      reset();
      clearSelectedItems();
    }
  }, [])

  ///* funciones
  const onSubmit = async (e: ISolicitudTrasladoForm) => {

    if (productos.length === 0)
      return setAlert(true, 'Agregar inventariables', AlertSeverityEnum.info)

    if (productos.some(e => e.cantidad == '0')) {
      return setAlert(true, `Hay algunos ítems con cantidad solicitada en 0. Por favor, revísalos y corrige la información.`, AlertSeverityEnum.error);
    }

    if (paginatedData.some(e => e.producto_data?.stock_actual == 0)) {
      return setAlert(true, 'Algunos productos tienen stock en 0.', AlertSeverityEnum.info)
    }

    setConfirmDialogIsOpen(true);

    setConfirmDialog({
      isOpen: true,
      title: '¡Confirmar!',
      subtitle:
        'Confirmar que deseas proceder con la solicitud de inventario. ¿Estás seguro de continuar?',
      onClose() {
        setConfirmDialogIsOpen(false);

      },
      async onConfirm() {
        const newProductoData = await handleAgregarUrlSerie(handleUploadFile);

        e.productos = newProductoData
        e.user = username!;
        e.estado_solicitud = EstadoSolicitudTransferencia.EN_ESPERA;
        e.observaciones = {
          observaciones_1: form.getValues().observacion_1
        }

        const resp = await fetchCreateSolicitudTransferenciaProducto.mutateAsync(e);
        if (resp.code == 200) {
          navigate(ROUTER_PATHS.inventario.solicitudInventarioNav)
          clearSelectedItems();
        }
        setConfirmDialogIsOpen(false);
        return
      },
      cancelTextBtn: 'Cerrar',
    });


  }


  return (
    <>
      <SingleTableBoxScene
        title="Crear Solicitud de Transferencia"
        enableBackBtn={true}
        backPageUrl={ROUTER_PATHS.inventario.solicitudInventarioNav}
        visibleReport={false}
        enableCreateOrEditBtn={true}
        iconCreateOrEdit={<ReceiptLongIcon />}
        textCreateOrEditBtn="Solicitar"
        fnCreateOrEdit={handleSubmit(onSubmit,
          () => {
            setAlert(true, texto.campos_obligatorios, AlertSeverityEnum.error);
          }
        )}
      >

        <Grid container spacing={3} >

          <DatosTransferenciaComponente
            control={control}
            errors={errors}
            form={form}
            reset={reset}
            onChangeDeleteItem={() => {
              clearSelectedItems();
            }}
          />

          {
            paginatedData.some(e => e.producto_data?.stock_actual == 0) && (
              <CustomAlertCard
                alertColor="info"
                alertTitle="Algunos productos tienen stock en 0."
                alertMessage="Te recomendamos buscar en otra ubicación o registrar un nuevo ingreso de inventario."
              />
            )
          }

          <Grid item {...gridSize}>
            <Paper className="paper-producto">
              <Grid container spacing={1} justifyContent={'space-between'} alignItems={'center'}>
                <Grid item >
                  <TabTextLabel text={'Items Seleccionado'} mt={0} pb={0} pl={0} pt={0} />
                </Grid>
                <Grid item>

                  < ModalUbicacionProductoSelectComponente
                    control={control}
                    ubicacion={form.getValues().ubicacion_origen!}
                    onChange={(e) => {

                      if (+e.stock_actual! <= 0)
                        return setAlert(true, `Producto con el codigo ${e.codigo} no tiene stock disponible.`, AlertSeverityEnum.warning);
                      const aux: MaterialTransferido = {
                        id: e.id_producto!,
                        codigo: e.codigo,
                        cantidad: "1",
                        series: [],
                        contiene_serie: e.contiene_serie,
                        producto_data: {
                          codigo: e.codigo,
                          categoria_producto: e.categoria_producto_data != null ? e.categoria_producto_data.nombre : "N/A",
                          subcategoria_producto: e.subcategoria_producto_data != null ? e.subcategoria_producto_data?.nombre : "N/A",
                          descripcion: e.descripcion ?? 'N/A',
                          stock_actual: e.stock_actual ?? '0',
                        },

                        ubicacion_origen: form.getValues().ubicacion_origen!,
                        ubicacion_destino: form.getValues().ubicacion_destino!,
                      }
                      handleAgregarProducto(aux);
                    }
                    }
                  />


                </Grid>
                <div className="linea"></div>
                <Grid item xs={12}>


                  <SampleTablePagination
                    columns={columnsSolicitudTransferenciaInventario}
                    data={paginatedData}
                    rowCount={productos.length}
                    setPagination={setPagination}
                    pagination={pagination}
                    rowNumber={true}
                  />

                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid >

      </SingleTableBoxScene >

      {/*MODAL DE PRODUCTOS*/}





    </>
  );
}